export default __webpack_public_path__ + "static/media/step8-icon.c6303adb.svg";